import { defineStore } from "pinia";

import modelClass from "@models/property";
import * as getters from "@modelStores/helpers/getters-helper";

export const usePropertyStore = defineStore("property-store", {
  state: () => {
    return {
      resources: [] as Record<string, unknown>[],
    };
  },
  getters: {
    ...getters,
    modelClass: () => modelClass,
  },
});
